import { useState } from 'react';
import {
  useCancelReservationMutation,
  useGetUserReservationsQuery,
} from '../../Api/reservations';
import useTranslate from '../../Hooks/useTranslate';
import Modal from '../../Style-guide/Modal';
import Title from '../../Style-guide/Title';
import ReservationItem from './reservationItem';
import MyReservationsWrapper from './style/myReservationsWrapper';

const MyReservations = () => {
  const { data: userReservationsData } = useGetUserReservationsQuery();
  const { mutate: cancelReservationRequest } = useCancelReservationMutation();
  const [showModal, setShowModal] = useState(false);
  const [selectedReservationId, setSelectedReservationId] = useState(null);
  const tr = useTranslate();

  const userReservations = userReservationsData ?? [];

  return (
    <MyReservationsWrapper>
      <Title size='MD'>{tr('my_reservations')}</Title>

      <div className='reservations-container'>
        {userReservations.map((item) => (
          <ReservationItem
            key={item.id ?? `${item.startTime}-${item.endTime}`}
            openModal={() => {
              setShowModal(true);
              setSelectedReservationId(item.id);
            }}
            data={item}
          />
        ))}
      </div>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        confirmation
        question={tr('cancel_reservation_modal_text')}
        confirmText={tr('yes_im_sure')}
        cancelText={tr('no_keep_it')}
        onConfirm={() =>
          cancelReservationRequest({
            params: { reservationId: selectedReservationId },
          })
        }
      />
    </MyReservationsWrapper>
  );
};

export default MyReservations;
